import { render, staticRenderFns } from "./SearchTextGroups.vue?vue&type=template&id=53c88ba8&"
import script from "./SearchTextGroups.vue?vue&type=script&lang=js&"
export * from "./SearchTextGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SearchTextGroups.vue"
export default component.exports